var map = {
	"./base.json": [
		"./translations/base.json",
		"translations_base_json"
	],
	"./de.json": [
		"./translations/de.json",
		"translations_de_json"
	],
	"./es.json": [
		"./translations/es.json",
		"translations_es_json"
	],
	"./fr.json": [
		"./translations/fr.json",
		"translations_fr_json"
	],
	"./it.json": [
		"./translations/it.json",
		"translations_it_json"
	],
	"./nb.json": [
		"./translations/nb.json",
		"translations_nb_json"
	],
	"./sv.json": [
		"./translations/sv.json",
		"translations_sv_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./translations lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;